import React from "react";
import HighlightedText from "../../../../components/HighlightKeyword";
export default function DraftSearchTable({ searchResults, query, openModal }) {
  return (
    <>
      <table className="case-law-table">
        <thead>
          <tr>
            <th style={{ minWidth: "10vw" }}>
              <div className="egazette-search-table-header">
                Publication Date
              </div>
            </th>
            <th style={{ width: "10%" }}>
              <div className="egazette-search-table-header">Page No</div>
            </th>
            <th style={{ minWidth: "20vw" }}>
              <div className="egazette-search-table-header">Text</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {searchResults.map((result, index) => (
            <tr key={index}>
              <td>
                {result?.metadata?.length > 0
                  ? new Date(
                      result.metadata[0]?.publicationDate
                    ).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                  : "Invalid Date"}
              </td>
              <td colSpan={2}>
                {result.chunks?.map((chunk, chunkIndex) => (
                  <div
                    key={chunkIndex}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "10% 90%",
                      alignItems: "start",
                      marginBottom: "10px",
                    }}
                  >
                    <span
                      style={{ textAlign: "center", verticalAlign: "middle" }}
                    >
                      {chunk.pageNumber}
                    </span>
                    <HighlightedText
                      paragraph={chunk.relevant_excerpt}
                      keyword={query}
                      onClick={() =>
                        openModal(result.fileUUID, chunk.pageNumber)
                      }
                    />
                  </div>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginBottom: "80px" }}></div>
    </>
  );
}
